import React from 'react';
import { func } from 'prop-types';
import { Mutation } from 'react-apollo';

import { DELETE_STORY } from 'graphql/deleteSaveStory';

export const DeleteSaveStoryMutation = props => (
  <Mutation mutation={DELETE_STORY}>
    {deleteStory => props.children(deleteStory)}
  </Mutation>
);

DeleteSaveStoryMutation.propTypes = {
  children: func.isRequired
};

export default DeleteSaveStoryMutation;
